import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { loading } from '@/decorators';

var LogsModal = function (_super) {
  __extends(LogsModal, _super);

  function LogsModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.loadingStatus = false;
    _this.total = 0;
    _this.dataList = [];
    _this.columns = [];
    _this.searchData = {};
    return _this;
  }

  LogsModal.prototype.setColumns = function () {
    this.columns = [{
      title: this.t('序号'),
      scopedSlots: {
        customRender: 'index'
      }
    }, {
      title: this.t('操作时间'),
      dataIndex: 'update_time',
      filterEmpty: true
    }, {
      title: this.t('操作人'),
      dataIndex: 'operator',
      filterEmpty: true
    }, {
      title: this.t('字段'),
      dataIndex: 'field',
      filterEmpty: true
    }, {
      title: this.t('更新前'),
      dataIndex: 'before_change',
      filterEmpty: true
    }, {
      title: this.t('更新后'),
      dataIndex: 'after_change',
      filterEmpty: true
    }];
  };

  LogsModal.prototype.initSearchData = function () {
    this.total = 0;
    return {
      bill_data_id: this.rowData.data.str_id,
      page_index: 1,
      page_size: 10
    };
  };

  LogsModal.prototype.queryList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data, list, total;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.finance.queryBillDataLogs(this.searchData)];

          case 1:
            data = _a.sent().data;
            list = data.list, total = data.total;
            this.dataList = list;
            this.total = total;
            return [2];
        }
      });
    });
  };

  LogsModal.prototype.handlePageChange = function (val) {
    this.searchData.page_index = val;
    this.queryList();
  };

  LogsModal.prototype.handleClose = function () {
    this.$emit('update:visible', false);
  };

  LogsModal.prototype.created = function () {
    this.setColumns();
  };

  LogsModal.prototype.handleVisibleChange = function () {
    if (this.visible) {
      this.searchData = this.initSearchData();
      this.queryList();
    } else {}
  };

  __decorate([Prop({
    type: Boolean,
    "default": false
  })], LogsModal.prototype, "visible", void 0);

  __decorate([Prop({})], LogsModal.prototype, "rowData", void 0);

  __decorate([loading('loadingStatus')], LogsModal.prototype, "queryList", null);

  __decorate([Watch('visible', {
    deep: true,
    immediate: true
  })], LogsModal.prototype, "handleVisibleChange", null);

  LogsModal = __decorate([Component], LogsModal);
  return LogsModal;
}(Vue);

export default LogsModal;